const OPEN_DRAWER = 'OPEN_DRAWER';
const CLOSE_DRAWER = 'CLOSE_DRAWER';
const INIT_DRAWER = 'INIT_DRAWER';

export {
	OPEN_DRAWER,
	CLOSE_DRAWER,
	INIT_DRAWER
};
